import React from 'react';
import { useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import Header from './Header';
import Footer from './Footer';
import CustomCursor from './CustomCursor';
import ThemeToggle from './ThemeToggle';
interface LayoutProps {
  children: React.ReactNode;
}
const Layout: React.FC<LayoutProps> = ({
  children
}) => {
  const location = useLocation();
  return <div className="font-poppins bg-white dark:bg-black text-[#121212] dark:text-white min-h-screen" data-id="element-78">
      <CustomCursor data-id="element-79" />
      <Header data-id="element-80" />
      <AnimatePresence mode="wait" data-id="element-81">
        <motion.main key={location.pathname} initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.5
      }} className="relative" data-id="element-82">
          {children}
        </motion.main>
      </AnimatePresence>
      <Footer data-id="element-83" />
      <ThemeToggle data-id="element-84" />
    </div>;
};
export default Layout;